import React, { useContext, useEffect, useState } from 'react';
import './Home.css';
import { useNavigate } from 'react-router-dom';
import {ReactComponent as SalesCommSvg} from '../../../assets/svgs/salescomm.svg';
import {ReactComponent as CirculationSvg} from '../../../assets/svgs/circulation.svg';
import {ReactComponent as RoobeekSvg} from '../../../assets/svgs/roobeek_logo.svg';
import config from '../../../config';
import { AppAuthGlobalVariables } from '../../../contexts/AppAuthContext';

function Home() {
	const {privs} = useContext(AppAuthGlobalVariables);
	const navigate = useNavigate();

	return (
		<div className='component-container home'>
			<div className='component-card'>
				<div className='home-wrapper'>
					<div className='title-card'>Your Applications</div>
					<div className='applications-box'>
						{privs?.P_CIRCULATION >= 'R' || privs?.P_PROVVIGIONI >= 'R' || privs?.P_ROOBEEK >= 'R' ?
							<>
								{privs?.P_CIRCULATION >= 'R'&&(<a className='application' href={config.CIRCULATION_URL} target='_blank' rel="noreferrer">
									<CirculationSvg className='application-icon'/>
									<div>Digital Circulation</div>
								</a>)}
								{privs?.P_PROVVIGIONI >= 'R'&&(<a className='application' href={config.SALES_COMM_URL} target='_blank' rel="noreferrer">
									<SalesCommSvg className='application-icon'/>
									<div>Sales Commissions</div>
								</a>)}
								{privs?.P_AVB >= 'R'&&(<a className='application' href={config.AVB_URL} target='_blank' rel="noreferrer">
									{/* <CirculationSvg className='application-icon'/> */}
									<div>AVB</div>
								</a>)}
								{privs?.P_ROOBEEK >= 'R' && config.ROOBEEK_URL!=='' ? 
									<a className='application' href={config.ROOBEEK_URL} target='_blank' rel="noreferrer">
										<RoobeekSvg className='application-icon'/>
										<div>Roobeek</div>
									</a>: ''}
							</>
						:
							<div className='user-no-privs-info'>
								<span>No Application assigned</span>
							</div>
						}
					</div>
				</div>
			</div>
		</div>
	)
}

export default Home
